import axios from 'axios';

// ES6 extend'ing is not working, http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript
export let BobTVSiteInterfaceError = function(message) {
    this.name = 'BobTVSiteInterfaceError';
    this.message = message;
    this.stack = (new Error()).stack;
};
BobTVSiteInterfaceError.prototype = Object.create(Error.prototype);
BobTVSiteInterfaceError.prototype.constructor = BobTVSiteInterfaceError;

export class BobTVSiteInterface {

    /**
     * @param {string} langPath
     */
    constructor(langPath = '/') {
        this.axios = axios.create({baseURL: langPath});
        this.axios.interceptors.response.use(this._responseResolveInterceptor, this._responseErrorInterceptor);
    }

    _responseResolveInterceptor(response) {
        let _response = response.data;

        if (!_response.status || _response.status !== 'success') {
            let error = new BobTVSiteInterfaceError(_response.message || _response.messages || '');
            error.code = _response.code;
            error.data = _response.data;
            //console.log('BobTVSiteInterface._responseResolveInterceptor()', error instanceof BobTVSiteInterfaceError);
            return Promise.reject(error);
        }

        return Promise.resolve(response)
    }

    _responseErrorInterceptor(error) {
        return Promise.reject(error);
    }

    /**
     * Sets required auth params to be sent with all site API requests
     *
     * @param {object} params
     */
    setAuthParams(params) {
        this._authParams = params;
    }

    getRequestData(params) {
        var mergedData = {
            ...this._authParams,
            ...params
        };

        var searchParams = new URLSearchParams();
        for (var param in mergedData) {
            searchParams.append(param, mergedData[param]);
        }

        return searchParams;
    }

    ageVerifUser() {
        return this.axios.get(
            '/_backend//member/age_verified/?v=1'
        );
    }

    getWallMaterial(id) {
        return this.axios.get(
            '/_backend/wall_material/',
            { params: { id }}
        );
    }

    follow(user) {
        return this.axios.post(
            '/_backend/member/follow/',
            this.getRequestData({id: user.uid})
        );
    }

    unfollow(user) {
        return this.axios.post(
            '/_backend/member/unfollow/',
            this.getRequestData({id: user.uid})
        );
    }

    block(user, reason, type) {
        return this.axios.post(
            '/_backend/member/block/',
            this.getRequestData({
                id: user.uid,
                reason: reason,
                type: type
            })
        );
    }

    setFCMToken(token) {
        return this.axios.post(
            '/_backend/member/pushapi/set-token/',
            this.getRequestData({ token })
        );
    }

    unblock(user) {
        return this.axios.post(
            '/_backend/member/unblock/',
            this.getRequestData({id: user.uid})
        );
    }

    giveToken(recipient_id, amount, room_id, serverId, pm) {
        return this.axios.post(
            '/_backend/member/wallet/give-token/',
            this.getRequestData({
                amount: amount,
                room_id: room_id,
                private: pm ? 1 : 0,
                server_id: serverId,
                recipient_id: recipient_id,
            })
        );
    }

    setUserMood(props) {
        return this.axios.post(
            '/_backend/member/chat-settings/set/',
            this.getRequestData({
                mood: props.mood,
                pm_enabled: props.pm_enabled,
                mood_visible: props.mood_visible
            })
        );
    }

    getUserMoodText() {
        return this.axios.post(
            '/_backend/member/chat-settings/',
        );
    }

    getDonateInfo() {
        return this.axios.post(
            '/_backend/payment/wallet/record/',
        );
    }

    getExclusionReasons() {
        return this.axios.post(
            '/_backend/exclude/reasons/',
        );
    }

    excludeUser(props) {
        return this.axios.post(
            '/_backend/exclude/',
            this.getRequestData({...props})
        );
    }

    login(props) {
        return this.axios.post(
            '/_backend/login/',
            this.getRequestData({...props})
        );
    }

    logout() {
        return this.axios.post(
            '/_backend/logout/'
        );
    }

    register(props) {
        return this.axios.post(
            '/_backend/register/',
            this.getRequestData({...props})
        );
    }

    passwordRecover(props) {
        return this.axios.post(
            '/_backend/password_recover/send.php',
            this.getRequestData({...props})
        );
    }

    activateByCode(props) {
        return this.axios.post(
            '/_backend/member/activate/by-code/',
            this.getRequestData({...props})
        );
    }

    activateRequestSMS(props) {
        return this.axios.post(
            '/_backend/member/activate/request-sms/',
            this.getRequestData({...props})
        );
    }
    
    getMemberNotificationList() {
        return this.axios.get(
            '/_backend/member/notification/',
            {
                params: {
                    unread: 1
                }
            }
        );
    }

    applyMemberNotificationAction({ ids }) {
        return this.axios.post(
            '/_backend/member/notification/action/',
            this.getRequestData({ ids, action: 'read' })
        );
    }

    refreshParentWindowUser() {
        if (window.opener && window.opener.postMessage) {
            try {
                window.opener.postMessage('refresh_current_user', '*');
            } catch(e) {}
        }
    }

    /**
     * @param {File} file
     */
    attachmentUpload(file) {
        var formData = new FormData();

        for (var name in this._authParams) {
            formData.append(name, this._authParams[name]);
        }
        formData.append('upload', file);

        return this.axios.post('/_backend/att/upload/', formData);
    }

    /**
     * @param {object} attachment
     * @param {string} attachment.id
     * @return {*}
     */
    attachmentDelete(attachment) {
        return this.axios.post(
            '/_backend/att/delete/',
            this.getRequestData({id: attachment.id})
        );
    }

    mute(props) {
        return this.axios.post(
            '/_backend/user/text/mute/',
            this.getRequestData({...props})
        );
    }

    unmute(props) {
        return this.axios.post(
            '/_backend/user/text/unmute/',
            this.getRequestData({...props})
        );
    }
    
    incrementWallItemViews(props) {
        return this.axios.post(
          '/_backend/member/wall/view/',
          this.getRequestData({...props})
        );
    }

    setRoomOptions(props) {
        return this.axios.post(
          '/_backend/member/room/update/',
          this.getRequestData({...props})
        );
    }
}


// WEBPACK FOOTER //
// ./src/interfaces/site/index.js